module.exports = __webpack_public_path__ + "img/1.c9b7d0a6.png";